import waitFor from "../../../utils/waitfor";

export default function hideBVQAButton($element) {
    waitFor(() => $element && !!$element.shadowRoot && $element.shadowRoot.getElementById('bv-question-btn'))
        .then(() => $element.shadowRoot.getElementById('bv-question-btn'))
        .then($button => $button.style.display = 'none');
}